import { render, staticRenderFns } from "./BeforeYouBegin.vue?vue&type=template&id=4980be66&"
import script from "./BeforeYouBegin.vue?vue&type=script&lang=js&"
export * from "./BeforeYouBegin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports